// Import the functions you need from the SDKs you need
import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA1xL4p2eYQgYv_4EDo_XZXgIHTd2mJAbQ",
  authDomain: "strandz-by-dee.firebaseapp.com",
  projectId: "strandz-by-dee",
  storageBucket: "strandz-by-dee.appspot.com",
  messagingSenderId: "842530295948",
  appId: "1:842530295948:web:26febabb9944f5c4a86ba9",
  measurementId: "G-EPWNMZ6W0W",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize secondary app (must use a custom name)
const appImg =
  getApps().find((app) => app.name === "appImg") ||
  initializeApp(firebaseConfig, "appImg");

export const auth = getAuth(app);
export const db = getFirestore(app);
export const imageDb = getStorage(appImg);
